<template>
    <video
        v-if="isVideoVisible"
        ref="videoElem"
        :class="$style.video"
        loop
        muted
        playsinline
        autoplay
        disablePictureInPicture
        itemprop="video"
    />
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'

import { useVideoController } from '@/composables/use-video-controller'

const props = defineProps<{ videoId?: string; videoUrl?: string }>()

const videoElem = ref<HTMLVideoElement>()
const isVideoVisible = ref(false)

const videoOptions = computed(() => ({
    videoId: props.videoId,
    videoUrl: props.videoUrl,
}))
const { showVideo, closeVideo } = useVideoController(videoOptions, videoElem, isVideoVisible)

defineExpose({
    showVideo,
    closeVideo,
})
</script>
<style module>
.video {
    display: block;
    pointer-events: none;
    grid-area: main;
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    animation-duration: 0.25s;
    animation-name: video-fade-in;
    animation-timing-function: ease-out;
    animation-fill-mode: both;
    animation-play-state: paused;
}

.video[data-playing] {
    animation-play-state: running;
}

@keyframes video-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>
